import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

/**
 * Google AdSense 廣告組件
 * @param {string} slot - AdSense 廣告單元 ID
 * @param {string} format - 廣告格式 ('auto', 'fluid', 'rectangle', 'horizontal', 'vertical')
 * @param {string} layout - 廣告佈局 (用於 in-article 等特殊格式)
 * @param {string} className - 自定義樣式類
 * @param {boolean} responsive - 是否為響應式廣告
 * @param {object} style - 自定義內聯樣式
 */
function AdUnit({ 
  slot = '1606186829', 
  format = 'auto',
  layout = '',
  className = '',
  responsive = true,
  style = {}
}) {
  const adRef = useRef(null);
  const hasLoaded = useRef(false);

  useEffect(() => {
    // 防止重複載入
    if (hasLoaded.current) return;

    try {
      // 確保 adsbygoogle 腳本已載入
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        hasLoaded.current = true;
      }
    } catch (error) {
      console.error('AdSense 載入錯誤:', error);
    }

    // Cleanup
    return () => {
      hasLoaded.current = false;
    };
  }, [slot]);

  return (
    <motion.aside
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`ad-container ${className}`}
      aria-label="廣告"
    >
      <div className="text-center mb-2">
        <span className="text-xs text-slate-400 dark:text-slate-600 uppercase tracking-wider">
          Advertisement
        </span>
      </div>
      
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client="ca-pub-4962994846652942"
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout || undefined}
        data-full-width-responsive={responsive ? 'true' : 'false'}
      />
    </motion.aside>
  );
}

export default AdUnit;